import { FC } from 'react';

import { Flex, Icon, Text } from '@servicetitan/anvil2';
import { core } from '@servicetitan/anvil2/token';
import IconWarning from '@servicetitan/anvil2/assets/icons/material/round/warning.svg';

import { InstalledEquipmentApiModel } from '../../common/api/equipments.api';

import { MessageBubble } from '../../common/components/message-bubble/message-bubble';
import { MessageOption } from '../../common/components/message-option/message-option';
import { getEquipmentLabel } from './search-equipment';

interface EquipmentOptionsProps {
    equipments: InstalledEquipmentApiModel[];
    onSelect: (equipment: InstalledEquipmentApiModel) => void;
    selectedEquipment: InstalledEquipmentApiModel | undefined;
}

export const EquipmentOptions: FC<EquipmentOptionsProps> = ({
    selectedEquipment,
    onSelect,
    equipments,
}) => {
    if (!equipments.length) {
        return (
            <MessageBubble isMine={false}>
                <Text>No equipment for the selected job</Text>
            </MessageBubble>
        );
    }

    return equipments.map(e => (
        <MessageOption
            key={e.equipment_id}
            active={e.equipment_id === selectedEquipment?.equipment_id}
            onClick={() => onSelect(e)}
        >
            <Flex direction="column">
                <Text>{getEquipmentLabel(e)}</Text>
                {!e.has_document_coverage && (
                    <Flex gap="1" alignItems="center">
                        <Icon
                            svg={IconWarning}
                            size="medium"
                            color={core.primitive.ColorRed500.value}
                        />
                        <Text size="small" style={{ color: core.primitive.ColorRed500.value }}>
                            No documentation available yet, responses may be inaccurate
                        </Text>
                    </Flex>
                )}
            </Flex>
        </MessageOption>
    ));
};
